import { useState } from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface AlreadyRegisteredSectionProps {
  basePath: string;
}

export function AlreadyRegisteredSection({ basePath }: AlreadyRegisteredSectionProps) {
  const navigate = useNavigate();
  const [cpf, setCpf] = useState('');

  const formatCPF = (value: string) => {
    const numbers = value.replace(/\D/g, '');
    if (numbers.length <= 11) {
      return numbers
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    }
    return value;
  };

  const handleCpfChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatCPF(e.target.value);
    setCpf(formatted);
  };

  const handleConsult = () => {
    if (cpf.trim()) {
      navigate(`${basePath}/segunda-via`, {
        state: { cpf: cpf.replace(/\D/g, '') },
      });
    }
  };

  return (
    <Box
      sx={{
        mt: 3,
        p: { xs: 2, md: 3 },
        bgcolor: 'white',
        borderRadius: 2,
        border: 'none',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        fontFamily: 'Manrope, sans-serif',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
        <Box
          component="img"
          src="/assets/logo/fi_12822534.png"
          alt="Ícone"
          sx={{
            width: 32,
            height: 32,
            objectFit: 'contain',
          }}
        />
        <Typography
          variant="subtitle1"
          fontWeight={700}
          sx={{
            fontFamily: 'Manrope, sans-serif',
            color: '#1a237e',
            fontSize: { xs: '1rem', md: '1.125rem' },
          }}
        >
          Precisa Reemitir o seu Pagamento?
        </Typography>
      </Box>
      <Typography
        variant="body2"
        sx={{
          mb: 3,
          color: '#666',
          fontFamily: 'Manrope, sans-serif',
          fontSize: { xs: '0.875rem', md: '0.9375rem' },
        }}
      >
        Gere a segunda via.
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
        <TextField
          fullWidth
          size="medium"
          placeholder="Digite o seu CPF*"
          value={cpf}
          onChange={handleCpfChange}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              handleConsult();
            }
          }}
          inputProps={{
            maxLength: 14,
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
              fontFamily: 'Manrope, sans-serif',
              '& fieldset': {
                borderColor: '#e0e0e0',
              },
              '&:hover fieldset': {
                borderColor: '#b0b0b0',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#1976D2',
              },
            },
            '& .MuiInputBase-input::placeholder': {
              color: '#999',
              fontFamily: 'Manrope, sans-serif',
            },
          }}
        />
        <Button
          variant="outlined"
          onClick={handleConsult}
          disabled={!cpf.trim() || cpf.replace(/\D/g, '').length < 11}
          sx={{
            borderRadius: 2,
            borderColor: '#64B5F6',
            color: '#1976D2',
            bgcolor: 'white',
            px: 3,
            py: 1.5,
            fontFamily: 'Manrope, sans-serif',
            fontWeight: 600,
            textTransform: 'none',
            fontSize: { xs: '0.875rem', md: '0.9375rem' },
            whiteSpace: 'nowrap',
            alignSelf: 'flex-start',
            '&:hover': {
              borderColor: '#1976D2',
              bgcolor: '#f5f5f5',
            },
            '&:disabled': {
              borderColor: '#e0e0e0',
              color: '#b0b0b0',
            },
          }}
        >
          Clique Aqui
        </Button>
      </Box>
    </Box>
  );
}

